/**
 * 全局record dom 操作组件
 */
var RECORD_DOM = {
    // 添加底层div的超出隐藏
    setRecordListContentHide() {
        var topDiv = document.getElementsByClassName('record-top-part')[0];
        var listDiv = document.getElementsByClassName('layout-record-list')[0];
        var letterDiv = document.getElementsByClassName('layout-letter-side-bar')[0];
        if(topDiv){
            topDiv.style = 'display: none;';
        }
        if(listDiv){
            listDiv.style = 'height: 0; overflow: hidden;';
        }
        if(letterDiv){
            letterDiv.style = 'display: none;';
        }
    },
    resetRecordListContentStyle() {
        var topDiv = document.getElementsByClassName('record-top-part')[0];
        var listDiv = document.getElementsByClassName('layout-record-list')[0];
        var bottomDiv = document.getElementsByClassName('bottom-menu-bar')[0];
        if(topDiv) {
            setTimeout(() => {
                topDiv.style = 'display: block;';
            }, 0);
        }
        if(listDiv) {
            setTimeout(() => {
                listDiv.style = 'padding-top: ' + topDiv.clientHeight + 'px;';
            }, 0);
        }

        setTimeout(() => {
            var recordListDiv = document.getElementById('RecordList');
            // console.error('resetRecordListContentStyle------', recordListDiv)
            var height = innerHeight;
                height = topDiv ? height-topDiv.clientHeight : height;
                height = bottomDiv ? height-bottomDiv.clientHeight : height-52;
            if(recordListDiv) {
                recordListDiv.style.height = height + 'px';
            }
        }, 20);
        
    },
    updateRecordListStyle() {
        var topDiv = document.getElementsByClassName('record-top-part')[0];
        var listDiv = document.getElementsByClassName('layout-record-list')[0];
        setTimeout(() => {
            if(topDiv && listDiv){
                listDiv.style.paddingTop = topDiv.clientHeight + 'px';
            }
        }, 10);
    },
    resetRecordLetterSideBarStyle(type) {
        var topDiv = null;
            topDiv = type == 'record' ? document.getElementsByClassName('record-top-part')[0] : topDiv;
            topDiv = type == 'chooserecord' ? document.getElementsByClassName('record-choose-bar')[0] : topDiv;
        var letterDiv = document.getElementsByClassName('layout-letter-side-bar')[0];
        if(topDiv && letterDiv){
            // 子元素还没渲染出来，无法获取childElement的个数，所以延迟一些
            setTimeout(() => {
                letterDiv.style = 'top: ' + topDiv.clientHeight + 'px; line-height:' + innerHeight*0.6/letterDiv.childElementCount + 'px';
            }, 20);
        }
    },
    resetChooseRecordLetterSideBarStyle() {
        var topDiv = document.getElementsByClassName('record-choose-bar')[0];
        var letterDiv = document.getElementsByClassName('layout-letter-side-bar')[0];
        if(topDiv && letterDiv){
            // 子元素还没渲染出来，无法获取childElement的个数，所以延迟一些
            setTimeout(() => {
                letterDiv.style = 'top: ' + (topDiv.clientHeight + 40) + 'px; line-height:' + innerHeight*0.6/letterDiv.childElementCount + 'px';
            }, 20);
        }
    },
}

export {
    RECORD_DOM
}